import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Map extends Component {
  constructor(props) {
    super(props);
    this.setMarker = this.setMarker.bind(this);
  }

  componentDidMount() {
    const { markers, theme } = this.props;
    const styledMap = theme.styles ? new window.google.maps.StyledMapType([...JSON.parse(theme.styles)], { name: 'Styled' }) : new window.google.maps.StyledMapType();

    this.gmap = new window.google.maps.Map(this.map, {
      zoom: 10,
      mapTypeControlOptions: {
        mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain', 'styled_map']
      },
      // disableDefaultUI: true,
      scrollWheel: false
    });
    this.gmap.mapTypes.set('styled_map', styledMap);
    this.gmap.setMapTypeId('styled_map');
    const markerBounds = new window.google.maps.LatLngBounds();
    markers.forEach((marker) => {
      this.setMarker(marker);
      markerBounds.extend(marker.position);
    });
    this.gmap.fitBounds(markerBounds);
    this.gmap.set('scrollWheel', false);
  }

  componentWillReceiveProps(nextProps) {
    const { markers } = this.props;
    const markerBounds = new window.google.maps.LatLngBounds();
    if (markers && (markers !== nextProps.markers)) {
      nextProps.markers.forEach((marker) => {
        this.setMarker(marker);
        markerBounds.extend(marker.position);
      });
      this.gmap.fitBounds(markerBounds);
    }
  }

  setMarker(marker) {
    const { theme } = this.props;
    const infoWindow = new window.google.maps.InfoWindow({
      content: `<h2 class="map-title">${marker.title}</h2>`
    });
    const mark = new window.google.maps.Marker({
      position: marker.position,
      title: marker.title,
      icon: theme.pin
    });
    mark.addListener('click', () => infoWindow.open(this.map, mark));
    mark.setMap(this.gmap);
  }

  render() {
    return (
      <div
        ref={(map) => { this.map = map; }}
        className="poi-map"
      >
        I am a map
      </div>
    );
  }
}

Map.propTypes = {
  markers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  theme: PropTypes.shape({})
};

export default Map;



// WEBPACK FOOTER //
// ./src/components/common/ui/Map.jsx